var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57474 2.67753L5.31264 2.47223L4.4293 0.29696C4.27039 -0.0989868 3.72824 -0.0989868 3.56933 0.29696L2.68599 2.47711L0.428564 2.67753C0.017273 2.71175 -0.150982 3.24946 0.16216 3.53297L1.87743 5.08743L1.36332 7.39468C1.26984 7.81507 1.7045 8.14747 2.05971 7.92261L3.99932 6.70055L5.93893 7.9275C6.29413 8.15236 6.72879 7.81996 6.63532 7.39957L6.1212 5.08743L7.83647 3.53297C8.14961 3.24946 7.98603 2.71175 7.57474 2.67753Z",
    fill: "#FFC20E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 3,
    height: 7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 3,
    height: 7,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57474 2.67753L5.31264 2.47223L4.4293 0.29696C4.27039 -0.0989868 3.72824 -0.0989868 3.56933 0.29696L2.68599 2.47711L0.428564 2.67753C0.017273 2.71175 -0.150982 3.24946 0.16216 3.53297L1.87743 5.08743L1.36332 7.39468C1.26984 7.81507 1.7045 8.14747 2.05971 7.92261L3.99932 6.70055L5.93893 7.9275C6.29413 8.15236 6.72879 7.81996 6.63532 7.39957L6.1212 5.08743L7.83647 3.53297C8.14961 3.24946 7.98603 2.71175 7.57474 2.67753Z",
    fill: "#E8EDF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star_half.9cd2ffb86efb7729ba5520b08f13291d.svg";
export { ForwardRef as ReactComponent };